import React from 'react';
import { cn, getStatusBadgeClasses } from '@/lib/utils';

interface StatusBadgeProps {
  status: string;
  className?: string;
  variant?: 'default' | 'rounded';
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Consistent status badge component for BayesPrep Admin Portal
 * Provides unified status display across all components
 */
export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  className,
  variant = 'default',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };

  const variantClasses = {
    default: '',
    rounded: 'rounded-full'
  };

  const statusClasses = getStatusBadgeClasses(status, cn(
    sizeClasses[size],
    variantClasses[variant],
    className
  ));

  // Custom display text for specific statuses
  const getDisplayText = (status: string) => {
    switch (status.toLowerCase()) {
      case 'published_assigned':
        return 'Published & Assigned';
      case 'on_demand':
        return 'On Demand';
      case 'in_progress':
        return 'In Progress';
      default:
        return status.charAt(0).toUpperCase() + status.slice(1).replace(/[_-]/g, ' ');
    }
  };

  return (
    <span className={statusClasses}>
      {getDisplayText(status)}
    </span>
  );
};

export default StatusBadge;
